module.exports = __webpack_public_path__ + "static/media/man-3.fcfc134f.svg";